import React, { useState } from "react";
import { Col, Row, Carousel, Image, Affix, Anchor, Button } from "antd";
import { useNavigate, Link } from "react-router-dom";


export const CorousalView = () => {
  const [container, setContainer] = useState(null);
  const navigate = useNavigate();
  const [scrollPosition, setScrollPosition] = useState("bottom");

  const imageList = [
    { image: "Banner_NYP_Closing_2025.jpg", external: true, link: "https://www.saasta.ac.za/programmes/focus-weeks/national-science-week/stakeholders-and-partners/", title: "", content: "" },
    { image: "banner3y.png", external: false ,link: "/", title: "Empowering Youth on the Path to Success", content: "Are you an unemployed science graduate under the age of 35 years old? The DSTI-NYS programme, which aims to instill a culture of community service and volunteerism, offers young people the chance to participate in skill-building opportunities and a way out of long-term unemployment by providing them with practical opportunities that increase their likelihood of accessing the economy and instill in them an understanding of their significant role in South Africa's development." },
  ];

  return (
    <div>
      <div>
        <Carousel
          autoplay
          className="corousal"
          dotPosition={scrollPosition}
          dots={true}
        >
          {imageList.map((item, index) => (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} key={index}>
                <div key={index}>
                  <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <a href={item.link} target={`${item.external ? "_blank" : "self"}`} >
                    <Image
                      alt="image"
                      src={require(`../../assets/${item.image.toString()}`)}
                      preview={false}
                      ref={setContainer}
                    />
                  </a>
                  </Col>
                  </Row>
                  <Affix
                    target={() => container}
                    className="carousel-desc"  
                  >
                    <Row>
                      <Col xs={1} sm={1} md={1} lg={2} xl={4}></Col>
                      <Col xs={23} sm={18} lg={16} xl={12}>
                        <h1 className="carousel-text">{item.title}</h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={1} sm={1} md={1} lg={2} xl={4}></Col>
                      <Col xs={23} sm={18} lg={16} xl={10}>
                        <p className="carousel-content-text">{item.content}</p>
                      </Col>
                    </Row>
                  </Affix>
                </div>
              </Col>
            </Row>
          ))}
        </Carousel>
      </div>
    </div>
  );
};
